import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const issueCreateEmbedRoute: InvariantJiraRoute = {
	name: 'issue-create-embed',
	path: '/jira/issues/create/embed',
};
